<template>
  <div>
    <Modal
      :width="500"
      :value="modalOpen"
      :title="modalData.title"
      :subtitle="modalData.subtitle"
      :cta-text="modalData.ctaText"
      :cancel-hidden="modalData.cancelHidden"
      @cancel="modalOpen = false"
      dialogIcon="danger"
      @confirm="confirmModal">
    </Modal>

    <ul class="tree" v-if="messageTree.length > 0">
      <LiveChatMp4TreeNode @openModal="openModal" :node.sync="messageTree[0]" :parent="null"></LiveChatMp4TreeNode>
    </ul>
  </div>
</template>

<script>
  import LiveChatMp4TreeNode from "./LiveChatMp4TreeNode.vue";
  import Modal from "@/components/custom/Modal.vue";
  import cloneDeep from "lodash/cloneDeep";

  export default {
    components: { LiveChatMp4TreeNode, Modal },
    props: {
      messageTree: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        modalOpen: false,
        modalData: {},
      };
    },
    methods: {
      openModal(data) {
        this.modalOpen = true;
        this.modalData = data;
      },
      confirmModal() {
        this.modalOpen = false;
        if (this.modalData.delete) {
          const children = cloneDeep(this.modalData.parent.children);
          this.modalData.parent.children = [];

          this.$nextTick(() => {
            children.splice(this.modalData.index, 1);
            this.modalData.parent.children = children;
          });
        }
      },
    },
  };
</script>

<style lang="scss">
  @import "@/@core/preset/preset/shortcodes.scss";
</style>
